import { CoachStyle, IReport } from '@interfaces/index';

export function applyFallbacks(value: IReport): void {
  if (!value.facilitatorStyleA && value.facilitatorInsight) {
    value.facilitatorStyleA = value.facilitatorInsight;
  }
  if (!value.facilitatorTrait && value.facilitatorInsight) {
    value.facilitatorTrait = value.facilitatorInsight;
  }
  if (!value.facilitatorTraitDesc && typeof value['facilitatorTraitDesc'] === 'undefined') {
    value.facilitatorTraitDesc = 'Default fallback description';
  }
}

export function normalizeFacilitatorReport(report: IReport): IReport {
  const extended = report as IReport & Record<string, string>;

  const primary = report.facilitatorStyleA || report.facilitatorOverview;
  if (isCoachStyle(primary)) {
    report.primaryCoachingStyle = primary;
  }

  const secondary = report.facilitatorInsight || extended['facilitatorInsightStyles2'];
  if (isCoachStyle(secondary)) {
    report.secondaryCoachingStyle = secondary;
  }

  const least = report.facilitatorTrait || extended['facilitatorInsightStyles3'];
  if (isCoachStyle(least)) {
    report.leastDevCoachingStyle = least;
  }

  report.primaryCoachingStyleDesc = extended['Top Style'] ?? report.facilitatorOverviewDesc ?? '';
  report.secondaryCoachingStyleDesc = extended['Second Style'] ?? report.facilitatorInsightDesc ?? '';
  report.leastDevCoachingStyleDesc = extended['Lowest Style'] ?? report.facilitatorTraitDesc ?? '';

  report.styleExpression = report.facilitatorTheme ?? '';
  report.styleExpressionDesc = extended['__StyleExpression'] ?? report.facilitatorThemeDesc ?? '';
  report.name = report.facilitatorSummary ?? '';

  return report;
}

/**
 * Safeguard for checking if the value is a valid CoachStyle.
 */
export function isCoachStyle(value: any): value is CoachStyle {
  return ['Rallier', 'Educator', 'Strategist', 'Provocateur', 'Explorer', 'Confidant', 'Transformer'].includes(value);
}

/**
 * Shared filename rule for a downloaded report PDF. The download endpoint sends
 * `Content-Disposition: attachment` with no `filename` parameter, so the client is
 * solely responsible for naming the file — every download site uses this rule.
 */
export function reportPdfFilename(report: IReport | null): string {
  if (!report) {
    return 'owlhub.pdf';
  }
  return `${report.name.replace(/\s+/g, '-')}_${report.completed_at}.pdf`;
}
